// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const MAP_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY = {
  TIMELINE_3D_ENABLED: 'timeline-3d-view.enabled',
  DISPLAY_SPATIAL_FILTER_GEOMETRIES: 'displaySpatialFilterGeometry',
  MAP_AUTOZOOM: 'map.autoZoom',
  SCALE_RANGE_MIN: 'map.scaleRange.min',
  SCALE_RANGE_MAX: 'map.scaleRange.max',
  LAYOUT: 'map.layout',
  LEGEND_ENABLED: 'map.legend.enabled',
  OVERVIEW_MAP_ENABLED: 'map.overview-map.enabled',
  OVERVIEW_MAP_HEIGHT: 'map.overview-map.height',
  OVERVIEW_MAP_FIXED_EXTENT: 'map.overview-map.fixedExtent',
  SIDEBAR_WIDTH: 'map.sidebar.width',
  EXTENT_FILTER_ACTION_SPATIAL_RELATION: 'map.extentFilterAction.spatialRelation',
  COORDINATE_DISPLAY_SRS_AUTHORITY: 'map.coordinateDisplaySrs.authority',
  COORDINATE_DISPLAY_SRS_REFERENCE_SYSTEM_ID: 'map.coordinateDisplaySrs.referenceSystemId'
} as const;

/** @see net/disy/cadenza/workbook/model/MapViewSettingsKey.java */
export type MapViewSettingsKey = keyof typeof MAP_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY;

export const MapViewSettingsKey = {
  values: Object.keys(MAP_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY) as readonly MapViewSettingsKey[],
  toPersistenceKey: (value: MapViewSettingsKey) => MAP_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = MapViewSettingsKey.values.find(key => MAP_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No MapViewSettingsKey for key: ${persistenceKey}`); }
    return value;
  },
} as const;

// </GENERATED-CODE>
